import { useAppMode } from "@/hooks/useAppMode";

const AppSplash = () => {
  const { provider } = useAppMode();

  // Use the same color as the provider name text in the header
  const bg = provider?.brand_header_text_color || "#000000";
  const displayName = provider?.display_name || provider?.name || "WellSuites";

  return (
    <div
      className="fixed inset-0 flex items-center justify-center overflow-hidden"
      style={{
        backgroundColor: bg,
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      {provider?.image_url && (
        <img
          src={provider.image_url}
          alt={displayName}
          className="object-contain"
          style={{ width: "30vmin", height: "30vmin" }}
        />
      )}
    </div>
  );
};

export default AppSplash;
